export const SET_TASKS = 'taskForwarding/SET_TASKS';
export const REMOVE_TASKS = 'taskForwarding/REMOVE_TASKS';
export const RESET_TASKS = 'taskForwarding/RESET_TASKS';
